import React from 'react'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import TireLinesList from './TireLinesList'
import EmptyTireLinesList from './EmptyTireLinesList'
import Promotions from 'components/PromotionResultList/PromotionsList/components'
import Link from 'components/common/Link/Link'
import Icon from 'components/common/Icon/Icon'
import SortByPrice from '../components/SortByPrice'

const BOTCommonBrandTireResultList = ({
  brandName,
  activeVehicle,
  handleStoreSearch,
  handleTiresSearch,
  hasActiveVehicle,
  products,
  storePhoneNumber,
  promotions,
  handlePromotionClick,
  hasStore
}) =>
  <>
    { (products.length > 0 && !!hasStore) && <SortByPriceElement />}

    <Wrapper>

      <TireLinesListWrapper>
        {
          products.length > 0 ?
            <TireLinesList
              brandName={ brandName }
              hasActiveVehicle={ hasActiveVehicle }
              handleStoreSearch={ handleStoreSearch }
              hasStore={ Boolean(storePhoneNumber) }
              products={ products } /> :
            <EmptyTireLinesList
              activeVehicle={ activeVehicle }
              handleTiresSearch={ handleTiresSearch }
              storePhoneNumber={ storePhoneNumber } />
        }
      </TireLinesListWrapper>
      {
        promotions.length > 0 &&
        <PromotionsWrapper>
          <MorePromotions>
            <Link data-promotions-all-details-link bolder to={ '/deals' }>
              View all deals <LinkIcon asset="caret-blue-right" />
            </Link>
          </MorePromotions>

          <Promotions
            homePageVersion={ false }
            promotionList={ promotions }
            handlePromotionClick={ handlePromotionClick } />
        </PromotionsWrapper>
      }
    </Wrapper>
  </>

export default BOTCommonBrandTireResultList

BOTCommonBrandTireResultList.propTypes = {
  activeVehicle: PropTypes.string,
  brandName: PropTypes.string,
  handlePromotionClick: PropTypes.func,
  handleStoreSearch: PropTypes.func,
  handleTiresSearch: PropTypes.func,
  hasActiveVehicle: PropTypes.bool,
  hasStore: PropTypes.shape(),
  products: PropTypes.arrayOf(PropTypes.arrayOf),
  promotions: PropTypes.arrayOf(PropTypes.shape()),
  storePhoneNumber: PropTypes.string
}

const Wrapper = styled.div`
  display: flex;
  ${Media.mobile`
    flex-direction: column;
    align-items: center;
  `}
`

const TireLinesListWrapper = styled.div`
  flex-grow: 2;
`

const PromotionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${Media.desktop`
    margin-right: 20px;
    border-left: 1px solid ${Theme.colors.light_grey};
    padding-left: 50px;
  `}
  ${Media.mobile`
    margin-top: 30px;
  `}
`

const SortByPriceElement = styled(SortByPrice)`
  margin-bottom: 30px;
`

const MorePromotions = styled.div`
  margin: 0 0 0 20px;
  padding-bottom: 10px;
  ${Media.mobile`
    max-width: 90vw;
  `}
`

const LinkIcon = styled(Icon)`
  width: 6px;
  margin-top: -2px;
`
